module.exports = __webpack_public_path__ + "static/img/loginbg.311d037d.jpg";